import React from "react";
import { Navigate, useLocation, useSearchParams } from "react-router-dom";
import { GuestSessionProvider } from "contexts/GuestSessionContext";
import GuestPortalShell from "./GuestPortalShell";
import GuestLandingRedirect from "./components/GuestLandingRedirect";
import GuestHub from "./GuestHub";
import GuestMenuPage from "./pages/GuestMenuPage";
import BuffetPage from "./pages/BuffetPage";
import CatalogRequestPage from "./pages/CatalogRequestPage";
import StayPage from "./pages/StayPage";
import HelpPage from "./pages/HelpPage";
import RequestsPage from "./pages/RequestsPage";
import OffersPage from "./pages/OffersPage";
import EventsPage from "./pages/EventsPage";

const pageFromPath = (pathname) => {
  const rest = pathname.replace(/^\/guest\/?/, "").replace(/\/$/, "");
  switch (rest) {
    case "dine":
      return <GuestMenuPage guestMode="dine" />;
    case "room-service":
      return <GuestMenuPage guestMode="room-service" />;
    case "buffet":
      return <BuffetPage />;
    case "housekeeping":
      return <CatalogRequestPage catalogKey="housekeeping" title="Housekeeping" />;
    case "laundry":
      return <CatalogRequestPage catalogKey="laundry" title="Laundry" />;
    case "maintenance":
      return <CatalogRequestPage catalogKey="maintenance" title="Maintenance" />;
    case "amenities":
      return <CatalogRequestPage catalogKey="amenities" title="In-room extras" />;
    case "stay":
      return <StayPage />;
    case "concierge":
      return <CatalogRequestPage catalogKey="concierge" title="Concierge" />;
    case "help":
      return <HelpPage />;
    case "requests":
      return <RequestsPage />;
    case "events":
      return <EventsPage />;
    case "offers":
      return <OffersPage />;
    default:
      return <GuestHub />;
  }
};

const GuestPortalApp = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const companyId = searchParams.get("companyId");
  const tableId = searchParams.get("tableId");

  if (!companyId) {
    return <Navigate to="/restaurants" replace />;
  }

  if (!tableId) {
    return (
      <Navigate
        to={`/restaurant-menu?companyId=${encodeURIComponent(companyId)}`}
        replace
      />
    );
  }

  return (
    <GuestSessionProvider>
      <GuestLandingRedirect>
        <GuestPortalShell>{pageFromPath(location.pathname)}</GuestPortalShell>
      </GuestLandingRedirect>
    </GuestSessionProvider>
  );
};

export default GuestPortalApp;
